import { Interval, Store, User, UserSubscription } from '@griply/types';

const isBlocking = (sub: UserSubscription, today: Date): boolean => {
  if (sub.store === Store.Promotional) {
    return false;
  }

  if (sub.interval === Interval.Lifetime) {
    return false;
  }

  if (sub.unsubscribedAt) {
    return false;
  }

  if (sub.expiresAt === null) {
    return true;
  }

  return sub.expiresAt.getTime() > today.getTime();
};

export const getBlockingSubscription = (
  user: User | null | undefined,
  today: Date,
): UserSubscription | null => {
  const subscriptions = user?.subscriptions;

  if (!subscriptions?.length) {
    return null;
  }

  return subscriptions.reduce<UserSubscription | null>((mostRecent, sub) => {
    if (!isBlocking(sub, today)) {
      return mostRecent;
    }
    if (!mostRecent) {
      return sub;
    }
    return sub.purchasedAt.getTime() > mostRecent.purchasedAt.getTime()
      ? sub
      : mostRecent;
  }, null);
};
